import { createContext } from 'react';

const CaFFeeContext = createContext({});

export default CaFFeeContext;
